import { db, firestore } from "./firebase";
import sessions from "./firebase_repositories/sessions_service";
// ******** SESSIONS Collection Start **********

export const getSessionPageVariables = async (
  sessionNumber,
  modyulNumber,
  pgNumber
) => {
  return await sessions.getSinglePage(sessionNumber, modyulNumber, pgNumber);
};

export async function getModulePages(sessionNumber, modyulNumber) {
  return await sessions.getAllPagesByModule(sessionNumber, modyulNumber);
}

// ******** SESSIONS Collection End **********

/**
 *
 * @param {string} userId
 * @param {string} module
 * @param {{}} data
 * @returns
 */
export function setPgAnswer(userId, module, data) {
  return db
    .collection("UserDetails")
    .doc(userId)
    .collection("progress")
    .doc("session1")
    .collection("modules")
    .doc(module)
    .update(data);
}

export function setPg1Answer(userId, answer) {
  return db
    .collection("UserDetails")
    .doc(userId)
    .collection("progress")
    .doc("session1")
    .collection("modules")
    .doc("module1")
    .update({
      pg1: {
        anoPipiliinMoAtBakit: answer,
      },
    });
}

export function getSessionProgressRef(userId, sessionNumber) {
  return db
    .collection("UserDetails")
    .doc(userId)
    .collection("progress")
    .doc("session" + sessionNumber);
}

export function updateSessionProgress(userId, sessionNumber, increment) {
  return db
    .collection("UserDetails")
    .doc(userId)
    .collection("progress")
    .doc("session" + sessionNumber)
    .set(
      { completionRate: firestore.FieldValue.increment(increment) },
      { merge: true }
    );
}

export function getProgress(userId, moduleNumber) {
  return db
    .collection("UserDetails")
    .doc(userId)
    .collection("progress")
    .doc("session1")
    .collection("modules")
    .doc(`module${moduleNumber}`);
}

export function getSessionProgressReference(
  userId,
  sessionNumber
) {
  return db
    .collection("UserDetails")
    .doc(userId)
    .collection("progress")
    .doc(sessionNumber)
}

export function getModuleProgressReference(
  userId,
  sessionNumber,
  moduleNumber
) {
  return db
    .collection("UserDetails")
    .doc(userId)
    .collection("progress")
    .doc(sessionNumber)
    .collection("modules")
    .doc(moduleNumber);
}

export function setProgress(userId, moduleNumber, prog) {
  return db
    .collection("UserDetails")
    .doc(userId)
    .collection("progress")
    .doc("session1")
    .collection("modules")
    .doc(`module${moduleNumber}`)
    .set(
      {
        progress: prog,
      },
      { merge: true }
    );
}

export function setStartDate(userId, session, module) {
  return db
    .collection("UserDetails")
    .doc(userId)
    .collection("progress")
    .doc(session)
    .collection("modules")
    .doc(module)
    .set(
      {
        dateStarted: firestore.FieldValue.serverTimestamp(),
        progress: 0,
      },
      { merge: true }
    );
}

export function setFinishDate(userId, session, module) {
  return db
    .collection("UserDetails")
    .doc(userId)
    .collection("progress")
    .doc(session)
    .collection("modules")
    .doc(module)
    .update({
      dateFinished: firestore.FieldValue.serverTimestamp(),
    });
}

export function setPg5Answer(userId, cb1, cb2, cb3, cb4, cb5) {
  return db
    .collection("UserDetails")
    .doc(userId)
    .collection("progress")
    .doc("session1")
    .collection("modules")
    .doc("module1")
    .update({
      pg5: {
        gumamitNgAtn: cb1,
        kumuhaNgInsurance: cb2,
        nagIponNgPera: cb3,
        nakaHiramNgPera: cb4,
        nakagamitNgEwallet: cb5,
      },
    });
}

export function getAsset1Pg3() {
  return db
    .collection("Sessions")
    .doc("session1")
    .collection("Modules")
    .doc("module1")
    .collection("Pages")
    .doc("pg3");
}

export function checkUsers(userID) {
  return db.collection("UserDetails").doc(userID).get();
}

export function checkUsers1(userID) {
  return db.collection("UserDetails").doc(userID);
}

export function createUserDetails(
  userId,
  email,
  phone,
  city,
  postal,
  province,
  street,
  value,
  fname,
  lname,
  sex,
  code
) {
  const batch = db.batch();

  const mainRef = db.collection("UserDetails").doc(userId);
  const progRef = db
    .collection("UserDetails")
    .doc(userId)
    .collection("progress")
    .doc("session1");
  const modRef = db
    .collection("UserDetails")
    .doc(userId)
    .collection("progress")
    .doc("session1")
    .collection("modules")
    .doc("module1");

  batch.set(mainRef, {
    account: {
      email: email,
      phone: phone,
    },
    address: {
      cityTown: city,
      postalCode: postal,
      province: province,
      streetAddress: street,
    },
    createdBy: {
      timestamp: new Date(Date.now()),
      userId: "User Created",
    },
    personalDetails: {
      birthDate: value,
      firstName: fname,
      fullName: fname + " " + lname,
      lastName: lname,
      sex: sex,
    },
    progress: {
      module: 1,
      page: 1,
      session: 1,
    },
    referral: {
      code: code,
      referUserId: "",
      timestamp: "",
    },
    verification: {
      status: "pending",
    },
  });

  batch.set(progRef, {
    completionRate: 0,
    dateFinished: "",
    dateStarted: "",
  });

  batch.set(modRef, {
    activity: {
      question1: "answer1",
      question2: "answer2",
    },
    dateFinished: "",
    dateStarted: "",
    pg1: {
      anoPipiliinMoAtBakit: "",
    },
    pg5: {
      gumamitNgAtn: "",
      kumuhaNgInsurance: "",
      nagIponNgPera: "",
      nakaHiramNgPera: "",
      nakagamitNgEwallet: "",
    },
    progress: 0,
  });

  batch.commit();

  return "success";
}

export function getBackgroundImage(){
  
  return db.collection("ARPvariables").doc("WebVariables");

}

export function EditAccountDetails(uid,fname,lname,phone,bday,street,city,prov,postal){
  return db.collection("UserDetails").doc(uid)
  .set(
    {
      account: {
        phone: phone,
      },
      address: {
        cityTown: city,
        postalCode: postal,
        province: prov,
        streetAddress: street,
      },
      personalDetails: {
        birthDate: bday,
        firstName: fname,
        lastName: lname,
        fullName: fname + " " + lname,
      }
    },
    { merge: true }
  );
}

export function getQuizVideos(){
  
  return db.collection("ARPvariables").doc("WebVariables");

}



export function getFPMAssests(){
  
  return db.collection("ARPvariables").doc("WebVariables");

}